import React from "react";
import styles from "./wabaDashboard.module.css";

const MetricsCards = ({ data }) => {
  const groups = [
    { name: "Genesys", values: data.Genesys },
    { name: "Espresso", values: data.Espresso },
    { name: "Total", values: data.Total },
  ];

  return (
    <div className={styles.grid}>
      <div className={`${styles.card} ${styles.interactions} `}>
        <h2 className={styles.title}>Interações</h2>
        <p className={styles.interactionsValue}>{data.Interactions}</p>
      </div>
      <div className={styles.cardContainer}>
        {groups.map((group) => (
          <div key={group.name} className={styles.card}>
            <h2 className={styles.title}>{group.name}</h2>
            <div className={styles.line}></div>
            <p>
              <span className={styles.label}>Min:</span>{" "}
              <span className={styles.min}>
                {group.values.MinDurationMS} ms
              </span>
            </p>
            <p>
              <span className={styles.label}>Max:</span>{" "}
              <span className={styles.max}>
                {group.values.MaxDurationMS} ms
              </span>
            </p>
            <p>
              <span className={styles.label}>Avg:</span>{" "}
              <span className={styles.highlight}>
                {group.values.AvgDurationMS} ms
              </span>
            </p>
          </div>
        ))}
      </div>

      {/* Card extra para Interactions */}
    </div>
  );
};

export default MetricsCards;
